import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * A work order saved as a draft may have no schedule yet — orderStartDate,
 * orderStartTime and timeZone are all nullable.
 *
 * `dayjs(null).format()` returns the *string* "Invalid Date", so combining the
 * parts yields "Invalid DateTInvalid Date", and passing that to `dayjs.tz()`
 * throws a RangeError out of Intl.DateTimeFormat rather than returning an
 * invalid dayjs. An `isValid()` check on the result is therefore too late — the
 * parts have to be validated before converting.
 */
export function hasSchedule(orderStartDate, orderStartTime) {
  return (
    !!orderStartDate &&
    !!orderStartTime &&
    dayjs(orderStartDate).isValid() &&
    dayjs(orderStartTime).isValid()
  );
}

/**
 * The work order's start, expressed in the viewer's own timezone.
 * Returns null when the schedule is incomplete or the zone is unusable, so
 * callers can render a placeholder instead of crashing the row.
 */
export function workOrderLocalDateTime(orderStartDate, orderStartTime, timeZone) {
  if (!hasSchedule(orderStartDate, orderStartTime)) return null;

  const combined = `${dayjs(orderStartDate).format("YYYY-MM-DD")}T${dayjs(
    orderStartTime,
  ).format("HH:mm:ss")}`;

  try {
    const converted = dayjs.tz(combined, timeZone || "UTC").tz(dayjs.tz.guess());
    return converted.isValid() ? converted : null;
  } catch {
    // Unrecognised IANA zone — Intl throws rather than returning invalid.
    return null;
  }
}
